
import store from '@/store/store';

export const segment_identify = (user_id, name, email, cellphone, created_at) => {
  const getTraits = store.getters.getTraits
  const data = {
    avg_markdown: getTraits.avg_markdown,
    avg_order: getTraits.avg_order,
    cellphone: getTraits.cellphone,
    country_id: getTraits.country_id,
    country_name: getTraits.country_name,
    different_products: getTraits.different_products,
    email: getTraits.email,
    name: name,
    phone: cellphone,
    created_at: created_at,
    failed_avg_order: getTraits.failed_avg_order,
    failed_coupons: getTraits.failed_coupons && getTraits.failed_coupons.split(', '),
    failed_different_products: getTraits.failed_different_products,
    failed_discounts: getTraits.failed_discounts,
    failed_donation_done: getTraits.failed_donation_done,
    failed_max_order: getTraits.failed_max_order,
    failed_orders_count: getTraits.failed_orders_count,
    failed_spent: getTraits.failed_spent,
    first_order_coupon: getTraits.first_order_coupon,
    first_order_date: getTraits.first_order_date,
    first_order_discount: getTraits.first_order_disscount,
    first_order_payment_type: getTraits.first_order_payment_type,
    first_order_products: getTraits.first_order_products,
    first_order_promos: getTraits.first_order_promos,
    first_order_subtotal: getTraits.first_order_subtotal,
    first_order_total_different_products: getTraits.first_order_total_different_products,
    first_order_total_items: getTraits.first_order_total_items,
    first_to_second: getTraits.first_to_second,
    frequency: getTraits.frequency,
    id: user_id,
    last_failed_order_date: getTraits.last_failed_order_date, 
    last_order_date: getTraits.last_order_date,
    max_order: getTraits.max_order,
    orders_count: getTraits.orders_count,
    products_ids: getTraits.products_ids,
    time_last_failed_order: getTraits.time_last_failed_order,
    time_last_order: getTraits.time_last_order,
    total_discounts: getTraits.total_discounts,
    total_donation_done: getTraits.total_donation_done,
    total_spent: getTraits.total_spent,
    used_coupons: getTraits.used_coupons,
    user_iddd: getTraits.user_iddd
  }
  if ((window as any).analytics) {
    (window as any).analytics.identify(user_id, data);
  }
}

export const segment_track = (event, props) => {
  const analytics = (window as any).analytics;
  analytics.track(event, props);
}

export const segment_page = () => {
  const analytics = (window as any).analytics;
  if(analytics) {
    analytics.page();
  }
}

export const parseSpecialCharacters = (str) => {
  const numberPattern = /\d+/g;
  return str.match(numberPattern).join('')
}
